// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m8FQJ","colBig":"styles_colBig__Ju0Y1","colSmall":"styles_colSmall__2K11o"};